<script>
    export default {
        props: {
            assetTypeID: Number,
            filterItem: Object
        },
        methods: {
            async selectFilterItem() {
                this.$store.commit('FILTER_ITEM_DATA_EDIT_SET', {
                    assetID: this.assetTypeID,
                    payload: this.filterItem,
                });
                this.$store.commit('IS_SHOW_FILTER_ITEM_EDIT', true);
                this.$store.dispatch('CHECK_FILTER_ITEM_EDIT');
            }
        }
    }
</script>


<template>
    <li>
        <div
            class="blur_white cursor_pointer_label"
            @click="selectFilterItem"
        >
            <label>[{{ filterItem['id'] }}]</label>
            <label
                class="ml_5"
            >{{ filterItem['name'] }}</label>
        </div>
    </li>
</template>